import { styled } from "styled-components";
import { Button, Image, Modal } from "antd";
import { useAppLayout } from "@dataone/lib";
import { useEffect } from "react";
import { CreditCardIcon } from "@dataone/icons";

interface UpdateModalCardProps {
  title: string;
  subTitle: string;
  containerId: string;
  isOpen: boolean;
  last4_card?: string;
  updateLoading: boolean;
  cancelFunction: () => void;
  updateFunction: () => void;
}

const UpdateModalCard = ({
  title,
  subTitle,
  containerId,
  cancelFunction,
  updateFunction,
  isOpen,
  last4_card,
  updateLoading,
}: UpdateModalCardProps) => {
  const { isSmartSearchVisible } = useAppLayout();

  useEffect(() => {
    if (isSmartSearchVisible) cancelFunction();
  }, [isSmartSearchVisible]);

  return (
    <StyledUpdateModalCard
      getContainer={containerId}
      open={isOpen}
      destroyOnClose
      width="30%"
      onCancel={cancelFunction}
      styles={{
        mask: {
          position: "absolute",
          borderRadius: "20px 40px 40px 40px",
        },
      }}
      closable={false}
      wrapClassName="absolute-modal-wrap"
    >
      <h3>{title} </h3>
      <p className="description">{subTitle}</p>
      <StyledDescription>
        <div>
          <StyledIcon>
            <CreditCardIcon />
          </StyledIcon>
          <p className="selected-title">Credit card </p>
        </div>
        <p className="type">Visa ending in {last4_card}</p>
      </StyledDescription>
      <StyledActionButtons updateLoading={updateLoading}>
        <Button type="default" key="cancel" onClick={cancelFunction}>
          Cancel
        </Button>
        <Button
          type="link"
          key="update"
          onClick={updateFunction}
          style={{ boxShadow: "none !important" }}
        >
          {updateLoading ? "Updating..." : "Update"}
        </Button>
      </StyledActionButtons>
    </StyledUpdateModalCard>
  );
};

export default UpdateModalCard;

export const StyledUpdateModalCard = styled(Modal)`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  h3 {
    text-align: center;
    margin-top: 5px;
  }

  .description {
    text-align: center;
    margin: 12px;
    font-size: 12px;
  }

  .modal-title {
    color: #f00;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 20px;
    text-align: center;
  }

  .modal-warning {
    border: none;
    height: 63px;
    background-color: rgba(255, 233, 217, 1);
    border-left: 6px solid rgba(210, 125, 63, 1);
    border-radius: 14px;
    color: #7f160c;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    .anticon svg {
      font-size: 22px;
      color: rgba(210, 125, 63, 1);
    }
  }

  .ant-modal-content {
    min-width: 350px;
    padding: 20px 30px;
    border-radius: 12px;
    width: 30%;
  }

  .ant-modal-footer {
    display: none;
    justify-content: center;
    margin-top: 20px !important;
    gap: 5px;
  }
`;
const StyledDescription = styled.div`
  background: #eff1fd;
  border-radius: 10px;
  padding: 12px;

  & > div {
    display: flex;
    .ant-form-item {
      margin: 0;
    }
  }

  p {
    margin-block: 6px 0;
    font-size: 13px;
  }
  .selected-title {
    color: #6f7d98;
    font-weight: 700;
    line-height: normal;
    font-size: 12px;
    margin-left: 5px;
    overflow: hidden;
    word-break: break-word;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 1;
  }
  .type {
    margin-top: 5px;
    margin-left: 3px;
    font-size: 12px;
  }
`;
const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  color: #6f7d98;
  font-size: 18px;
  margin-top: 5px;
`;

const StyledActionButtons = styled.div<{ updateLoading: boolean }>`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;

  .ant-btn-default,
  .ant-btn-link {
    width: calc(50% - 30px);
    height: 40px;
    box-shadow: none !important;
    border: none;
    font-size: 12px;
  }
  .ant-btn-default {
    background: #eff1fd;
    color: #040726 !important;
    font-weight: 700;
  }
  .ant-btn-link {
    margin-left: 10px;
    background: #4974f6 !important;
    color: #fff !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    cursor: ${(props) => (props.updateLoading ? "not-allowed" : "pointer")};

    &:focus,
    &:active {
      box-shadow: none !important;
      outline: none !important;
    }
    &&& {
      box-shadow: none !important;
      outline: none !important;
    }
  }
`;
